// Color palette configuration
export const colors = {
  // Primary colors
  primary: {
    main: "#1e293b", // Slate 800
    light: "#334155", // Slate 700
    dark: "#B0D9E7", // Slate 900
    contrastText: "#000",
  },
  secondary: {
    main: "#667eea", // Indigo 500
    light: "#818cf8", // Indigo 400
    dark: "#4f46e5", // Indigo 600
    contrastText: "#ffffff",
  },

  // Success colors
  success: {
    main: "#059669", // Emerald 600
    light: "#10b981", // Emerald 500
    dark: "#047857", // Emerald 700
    contrastText: "#ffffff",
  },

  // Error colors
  error: {
    main: "#dc2626", // Red 600
    light: "#ef4444", // Red 500
    dark: "#b91c1c", // Red 700
    contrastText: "#ffffff",
  },

  // Warning colors
  warning: {
    main: "#f59e0b", // Amber 500
    light: "#fbbf24", // Amber 400
    dark: "#d97706", // Amber 600
    contrastText: "#ffffff",
  },

  // Info colors
  info: {
    main: "#3b82f6", // Blue 500
    light: "#60a5fa", // Blue 400
    dark: "#2563eb", // Blue 600
    contrastText: "#ffffff",
  },

  // Neutral colors
  grey: {
    50: "#f8fafc", // Slate 50
    100: "#f1f5f9", // Slate 100
    200: "#e2e8f0", // Slate 200
    300: "#cbd5e1", // Slate 300
    400: "#94a3b8", // Slate 400
    500: "#64748b", // Slate 500
    600: "#475569", // Slate 600
    700: "#334155", // Slate 700
    800: "#1e293b", // Slate 800
    900: "#0f172a", // Slate 900
  },

  // Background colors
  background: {
    default: "#fafbfc",
    paper: "#ffffff",
    secondary: "#f8fafc",
    tertiary: "#f1f5f9",
  },

  // Text colors
  text: {
    primary: "#1e293b",
    secondary: "#64748b",
    disabled: "#94a3b8",
  },
};

export default colors;
